import React from 'react';
import { Box } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const EarningsChart = () => {
  const data = [
    { time: '0h', amount: 20.67 },
    { time: '3h', amount: 37.00 },
    { time: '6h', amount: 45.90 },
    { time: '9h', amount: 26.01 },
    { time: '12h', amount: 57.89 }
  ];

  // 自定义提示框
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <Box sx={{
          bgcolor: 'white',
          p: 1,
          border: '1px solid #ccc',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
          textAlign: 'center'
        }}>
          <Box sx={{ fontWeight: 'bold', fontSize: '16px' }}>
            ${payload[0].value.toFixed(2)}
          </Box>
        </Box>
      );
    }
    return null;
  };

  return (
    <Box sx={{ height: 300, mb: 2 }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 20, right: 20, left: 0, bottom: 20 }}>
          <defs>
            <linearGradient id="colorAmount" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="white" />
              <stop offset="100%" stopColor="#E0BBE4" />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E0E0E0" />
          <XAxis 
            dataKey="time" 
            axisLine={false} 
            tickLine={false} 
            tick={{ fill: '#999', fontSize: 12 }}
            dy={10}
          />
          <YAxis 
            axisLine={false} 
            tickLine={false} 
            tickFormatter={(value) => `$${value}`} 
            tick={{ fill: '#999', fontSize: 12 }} 
            domain={['dataMin - 5', 'dataMax + 5']}
          />
          <Tooltip content={<CustomTooltip />} />
          <Line
            type="monotone"
            dataKey="amount"
            stroke="url(#colorAmount)"
            strokeWidth={3}
            dot={false}
            activeDot={{ 
              fill: '#FF1493', 
              stroke: 'white', 
              strokeWidth: 2, 
              r: 6,
              strokeDasharray: '' 
            }}
            label={({ x, y, value }) => (
              <g>
                <circle cx={x} cy={y} r={6} fill="white" stroke="#FF1493" strokeWidth={2} />
                <text 
                  x={x} 
                  y={y - 15} 
                  fill="#000" 
                  textAnchor="middle" 
                  dominantBaseline="middle"
                  fontSize={12}
                  fontWeight="bold"
                >
                  ${value.toFixed(2)}
                </text>
              </g>
            )}
          />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default EarningsChart;
